import simpleSoilAttribute from './simpleSoilAttribute';

export const T_FACTOR = simpleSoilAttribute({
  key: 'T Factor',
  ratingCol: {
    displayString: 'Rate (tons/acre/year)',
    accessor: 'mapUnitRatingString',
  },
  ruleId: '75',
  shortFormData: {
    AggregationMethod: 'Dominant Condition',
    TiebreakRule: '-1',
  },
  units: 'tons/acre/year',
});
